import React from 'react'
import { Box } from '@mui/material'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const Parent = ({ bc, children, height }) => (
	<Box
		sx={{
			position: 'relative',
			height: height,
			zIndex: 1,
			backgroundColor: bc
		}}
	>
		{children}
	</Box>
)

const FakeBgImage = ({ src, fluid, title, height, borderRadius }) => {
	const image = getImage(fluid)
	return (
		<Box
			sx={{
				position: 'absolute',
				width: '100%',
				top: 0,
				left: 0,
				zIndex: -1,
				objectFit: 'cover!important',
				borderRadius: borderRadius
			}}
		>
			{image ? (
				<GatsbyImage image={image} alt={title} style={{ width: '100%', height: height }} />
			) : (
				<Box component={'img'} src={src} alt={title} style={{ width: '100%', height: height, objectFit: 'cover' }} />
			)}
		</Box>
	)
}

const Content = ({ children, bc }) => (
	<Box
		sx={{
			backgroundColor: bc,
			position: 'absolute',
			top: 0,
			height: '100%',
			width: '100%'
		}}
	>
		{children}
	</Box>
)

const BgImage = ({ src, fluid, title, height, overlayColor, children, borderRadius }) => (
	<Parent bc={overlayColor} height={height}>
		<FakeBgImage  src={src} fluid={fluid} title={title} height={height} borderRadius={borderRadius} />
		<Content bc={overlayColor}>{children}</Content>
	</Parent>
)

export default BgImage
